const o="4.6.1";export{o as VERSION};
